export default "__VITE_ASSET__Ded02ugT__"